import { InfoOutlined } from '@mui/icons-material'
import { StyledAdditionalMessage, StyledContainer, StyledMessages } from './styles/Alert.style'

interface AlertProps {
  icon?: React.ReactNode
  mainMessage: string
  additionalMessage?: string
}

export const Alert = ({
  icon = <InfoOutlined fontSize="small" />,
  mainMessage,
  additionalMessage,
}: AlertProps) => {
  return (
    <StyledContainer>
      {icon}
      <StyledMessages>
        <span>{mainMessage}</span>
        {additionalMessage && (
          <StyledAdditionalMessage>{additionalMessage}</StyledAdditionalMessage>
        )}
      </StyledMessages>
    </StyledContainer>
  )
}
